import type { InputState } from './actions';

const PULSES: Record<string, 'laneLeft' | 'laneRight' | 'hop' | 'pause' | 'horn'> = {
  ArrowLeft: 'laneLeft',
  KeyA: 'laneLeft',
  ArrowRight: 'laneRight',
  KeyD: 'laneRight',
  Space: 'hop',
  KeyP: 'pause',
  KeyH: 'horn',
  Escape: 'pause',
};

const HOLDS: Record<string, 'gas' | 'brake'> = {
  ArrowUp: 'gas',
  KeyW: 'gas',
  ArrowDown: 'brake',
  KeyS: 'brake',
};

/** True when the player is typing in a text box: driving keys must not steal those letters. */
export function isTyping(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  return target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement || target instanceof HTMLSelectElement || target.isContentEditable;
}

export function bindKeyboard(input: InputState, target: Window = window): () => void {
  const onDown = (event: KeyboardEvent): void => {
    if (isTyping(event.target)) return;
    const hold = HOLDS[event.code];
    if (hold) {
      input.hold(hold, `key:${event.code}`, true);
      event.preventDefault();
      return;
    }
    const pulse = PULSES[event.code];
    if (pulse && !event.repeat) {
      input.press(pulse);
      event.preventDefault();
    }
  };
  const onUp = (event: KeyboardEvent): void => {
    if (isTyping(event.target)) return;
    const hold = HOLDS[event.code];
    if (hold) input.hold(hold, `key:${event.code}`, false);
  };
  const onBlur = (): void => input.releaseAll();

  target.addEventListener('keydown', onDown);
  target.addEventListener('keyup', onUp);
  target.addEventListener('blur', onBlur);
  return () => {
    target.removeEventListener('keydown', onDown);
    target.removeEventListener('keyup', onUp);
    target.removeEventListener('blur', onBlur);
  };
}
